import { isInternalTier, isStaff } from "../../data/user/utils";

type MultisessionUser = {
  multisession_check_disabled?: boolean | null;
  roles?: unknown;
  /**
   * @deprecated read via {@link isInternalTier} only until staff are migrated.
   * The raw legacy column, not the entitlement-resolved tier — a live grant can
   * resolve an internal user to another tier and lose this bypass.
   */
  legacy_subscription_tier?: string | null;
};

/**
 * Artis staff run unlimited concurrent sessions on the same device type.
 *
 * The `artis_internal` arm is transitional: existing internal users do not have
 * the staff role yet, and dropping it before they are migrated would start
 * kicking them out of their own sessions. See docs/subscription-tier-removal.md.
 */
export const isMultisessionCheckBypassed = (user: MultisessionUser | null | undefined) =>
  Boolean(user?.multisession_check_disabled || isStaff(user?.roles) || isInternalTier(user?.legacy_subscription_tier));
